import MessageItem from './MessageItem';
import React from 'react';

export default function MessageList({ msg }) {
  return (
    <div>
      {msg.length > 0 &&
        msg.map((message, index) => {
          return <MessageItem key={index} message={message} />;
        })}
    </div>
  );
}
